import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import EndingEarly from './EndingEarly.svg';
import './EndingEarlyPopup.css';

export const EndingEarlyPopup = ({ handleCloseDialog }) => (
  <div className="a">
    <div className="row">
      <div className="col p-0">
        <img alt="welcome" className="imag-modal w-100" src={EndingEarly} />
      </div>
    </div>
    <div className="row py-4 text-center">
      <div className="col">
        <div className="h5 t-30 t-md-44">Awesome!</div>
        <p className="t-16 t-md-18">
          Sit back, relax, and we’ll contact you right away!
        </p>
      </div>
    </div>
    <div className="row">
      <div className="col text-center pb-2">
        <Button
          onClick={handleCloseDialog}
          className="btn-primary px-7 mb-5"
          rounded
          title="TAKE ME TO MY DASHBOARD"
        />
      </div>
    </div>
  </div>
);

EndingEarlyPopup.propTypes = {
  handleCloseDialog: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Popup/EndingEarlyPopup/EndingEarlyPopup.js